// extracted by mini-css-extract-plugin
export default {"settings_container":"SettingsView_settings_container__sRiGc","account_images":"SettingsView_account_images__ZBtkP","settings_blurbs":"SettingsView_settings_blurbs__YOswG"};